import { render, staticRenderFns } from "./accounts-payable-summary-detail.vue?vue&type=template&id=2461574c&scoped=true"
import script from "./accounts-payable-summary-detail.vue?vue&type=script&lang=js"
export * from "./accounts-payable-summary-detail.vue?vue&type=script&lang=js"
import style0 from "./accounts-payable-summary-detail.vue?vue&type=style&index=0&id=2461574c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461574c",
  null
  
)

export default component.exports